<template>
    

    <div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>Business</InputGroupAddon>
    <Dropdown v-model="value" 
        :options="options" 
        :disabled="disabled"
        :class="{'p-invalid': isError}" 
           />
        </InputGroup>
</div>


     
</template>  
<script>


import CommonService from "../../service/CommonService";
export default {
    props: ['modelValue', 'disabled'],
    emits:["update:modelValue","update:error"],
    data() {
        return {
            value: null,
            options: []
        }
    },
    CommonService:null,
    created(){
        let self=this;
        this.CommonService = new CommonService();
        this.value = (this.modelValue);
        this.CommonService.GetBusinessType().then((data) => {
            self.options = data
        }) 
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
   
    computed: {
        isError() {
            return  !this.disabled &&  !this.value      ;
        },
    },
    watch: {
            value: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
    
 
}
</script>
  
